import _ from 'underscore';
import { getCommonFilterConfig } from '@bingads-webui-campaign/common-grid-config';
import * as filterPreferences from '@bingads-webui-component-legacy/bingads-grid/service/filter-preferences';
import { sessionStore } from '@bingads-webui/js-data-storage';

function mapKeyValue(object, fn) {
  return _.chain(object)
    .pairs()
    .map(fn)
    .object()
    .value();
}


const schema = ({
  i18n,
  isBrandProtectionEnabled,
  isBrandExclusionEnabled,
}) => {
  const typeEnums = {};
  if (isBrandProtectionEnabled && isBrandExclusionEnabled) {
    typeEnums.both = _TL_('Both protection & exclusion');
  }
  if (isBrandProtectionEnabled) {
    typeEnums.protection = _TL_('Only protection');
  }
  if (isBrandExclusionEnabled) {
    typeEnums.exclusion = _TL_('Only exclusion');
  }
  typeEnums.none = _TL_('None');
  return {
    name: 'BroadOnlyBrandLists',
    type: 'object',
    properties: {
      BrandListType: {
        type: 'string',
        title: i18n.getString(_TL_('List type')),
        chooseType: 'select',
        filterable: true,
        customColumn: true,
        enum: Object.keys(typeEnums),
        localized: mapKeyValue(typeEnums, ([key, value]) => [
          `Enum.BrandListType'${key}'`,
          i18n.getString(value),
        ]),
      },
    },
  };
};

export function getFilterConfig({
  i18n,
  isBrandProtectionEnabled,
  isBrandExclusionEnabled,
}) {
  const filterConfig = getCommonFilterConfig({
    preferenceService: {},
    featureName: 'BroadOnlyBrandLists',
    entitySchema: schema({
      i18n,
      isBrandProtectionEnabled,
      isBrandExclusionEnabled,
    }),
    i18n,
    legacyGlobalI18n: i18n,
    sessionStore,
    preferenceStoreFactory: filterPreferences.getFilters,
    schemaI18nCampaign: {},
    dataContextManager: {},
    jsdata: {},
    updatePilot: false,
    enableCampaignWaterfall: false,
    editor: {},
  });

  return filterConfig;
}
